import React, { useEffect } from 'react';
import VignetteArticle from '../../Vignette/VignetteArticle';
import './Article.scss';

const Article = (props) => {
    const { articleVignetteId, match } = props;

    useEffect(() => {
        if (document.querySelector('.App'))
            document.querySelector('.App').classList = "App vignette-article";

        // Select vignette youtube video
        const targetNode = document.querySelector('body');
        const config = { attributes: true, childList: true, subtree: true };

        const callback = function (mutationsList, observer) {
            const $iframeNode = document.querySelector('iframe[src*="youtube"]');

            if ($iframeNode) {
                $iframeNode.parentElement.style.position = "relative";
                $iframeNode.parentElement.style.paddingBottom = "56%";

                return observer.disconnect();
            }

            window.setTimeout(() => {
                return observer.disconnect();
            }, 5000)
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

    }, [])

    if (document.querySelector('.App'))
        document.querySelector('.App').classList = "App article";

    return (
        <VignetteArticle articleId={match.params.id} />
    )
}

export default Article



// WEBPACK FOOTER //
// ./src/Components/Article/Article.jsx